import React from 'react';
//import GetFormTouchSection from './GetFormTouchSection';

const SEO = () => {
    return (
<>
  <section
    className="seo-ban text-center"
    style={{ backgroundImage: "url(assets/img/seo-bg.png)" }}
  >
    <i className="glow-2" />
    <div className="container-lg inner-container position-relative">
      <h1 className="seo-ts-head">
        Upscale your business with a top B2B SEO agency
      </h1>
      <h2 className="seo-ts-head-2">Don’t panic. It’s organic.</h2>
      <div className="row justify-content-center">
        <div className="col-lg-9">
          <p>
            At Purplepatch Services, we specialize in elevating your online
            presence organically. We understand the intricacies of SEO and are
            here to ensure your B2B business doesn't just get found; it stands
            out. Our approach is methodical, strategic, and tailored to your
            unique business needs, driving not just traffic, but the right
            traffic to your website.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section
    className="top-places"
    style={{ backgroundImage: "url(assets/img/top-places.png)" }}
  >
    <i
      className="top-places-shape"
      style={{ backgroundImage: "url(assets/img/top-places-shape.png)" }}
    />
    <div className="container-lg inner-container position-relative text-white">
      <div className="row">
        <div className="col-xl-5 col-md-6 pe-lg-4">
          <h2>
            Maximize Your B2B Website's Potential with Our Proven{" "}
            <span className="c-F0B2FF">SEO</span> Strategies
          </h2>
          <p>
            In the competitive B2B marketplace, a robust SEO strategy is
            essential for standing out. It's not just about climbing search
            rankings; it's about establishing your brand's authority and
            reaching your ideal clients efficiently. Our SEO services are
            designed to ensure that your website becomes a powerful
            lead-generating tool, driving relevant traffic and increasing your
            online visibility where it matters most.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section className="bg-010101 ui-pt-res-100 ui-pb-res-60">
    <div className="container-lg inner-container position-relative text-white">
      <h4 className="ts-parallel ui-mb-res-60 text-white">
        Our B2B SEO Approach
      </h4>
      <div className="row rw-divide-1">
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 analyze-icon"></div>
            <h5>Analyze</h5>
            <p>
              Our journey begins with meticulous research and strategic
              planning. We immerse ourselves in understanding your target
              customers and conduct comprehensive research to identify your most
              profitable opportunities. This includes intent-based keyword
              research, competitor analysis, content audits, and technical SEO
              audits, forming the foundation of a strategy tailored to elevate
              your product in the digital landscape.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 grow-icon"></div>
            <h5>Grow</h5>
            <p>
              With a clear strategy in place, we focus on strengthening your SEO
              foundations. This stage is all about gap-filling and fine-tuning –
              from updating title tags and optimizing website performance to
              creating targeted solution pages and resolving technical errors.
              We balance your business goals with your customers' needs and
              Google's requirements, ensuring optimal ranking and visibility.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 expand-icon"></div>
            <h5>Expand</h5>
            <p>
              As your foundations solidify, we scale up to boost your site's
              performance further. Our approach includes producing high-quality
              content, building authoritative links, and forging strategic
              partnerships to increase your domain authority. You'll see a
              significant rise in inbound traffic and organic leads, outpacing
              your competition.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 validate-icon"></div>
            <h5>Validate</h5>
            <p>
              At this stage, we assess the influx of new website visitors and
              organically sourced leads, fine-tuning our approach based on their
              conversion rates. We work closely with you to ensure that these
              leads are not just numbers but valuable prospects ready for
              engagement.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 refine-icon"></div>
            <h5>Refine</h5>
            <p>
              Now, your inbound marketing machine is running at full throttle.
              We'll dive into the analytics to measure the return on your
              investment, ensuring our efforts are yielding high-value leads. We
              continuously refine our strategy, focusing on your most
              significant business opportunities to maximize success in the
              coming year.
            </p>
          </div>
        </div>
      </div>
      <h4 className="ts-parallel ui-mb-res-30 ui-pt-res-30 text-white">
        Our B2B SEO Services
      </h4>
      <div className="row">
        <div className="col-xl-10">
          <p className="wee-off">
            We offer comprehensive B2B SEO services tailored to meet the
            specific needs of your business. From strategy formulation to
            execution, we ensure every aspect of your online presence is
            optimized for maximum impact.
          </p>
        </div>
      </div>
      <div className="row rw-divide-1">
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 seo-icon"></div>
            <h5>SEO Strategy</h5>
            <p>
              Our SEO strategy is a bespoke plan crafted to align with your
              business goals and target audience. We focus on long-term growth,
              ensuring your website not only reaches but also maintains high
              search engine rankings. This strategy includes a mix of on-page
              and off-page optimization, content strategy, and continuous
              monitoring to adapt to the ever-changing algorithms of search
              engines. Our goal is to increase your digital footprint and ensure
              that your business is prominently positioned in relevant search
              results.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 website-audits-icon"></div>
            <h5>Website Audits</h5>
            <p>
              We conduct thorough website audits to identify areas for
              improvement, ensuring your site is fully optimized for both user
              experience and search engine performance. Our audits cover
              everything from site speed and mobile-friendliness to content
              relevance and user engagement metrics. By pinpointing and
              addressing these critical factors, we ensure your website is not
              only search engine friendly but also delivers a superior user
              experience.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 keyword-icon"></div>
            <h5>Keyword Research</h5>
            <p>
              Our keyword research is meticulous, targeting terms and phrases
              that your ideal customers are searching for, ensuring your content
              resonates and ranks effectively. We delve into search trends, user
              intent, and industry-specific language to build a keyword strategy
              that captures both volume and relevance. This approach helps in
              driving targeted traffic to your site, increasing the likelihood
              of conversion.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 depth-icon"></div>
            <h5>In-Depth Competitor Analysis</h5>
            <p>
              We analyze your competitors to understand their strategies and
              identify opportunities for your business to stand out in the
              digital landscape. By examining their SEO tactics, keyword
              utilization, and content approach, we gain insights that help in
              crafting a more effective strategy for your business. This
              analysis ensures that you stay one step ahead in the competitive
              digital market.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 on-page-icon"></div>
            <h5>On-Page Optimization</h5>
            <p>
              Our on-page optimization ensures that every element of your
              website, from content to meta tags, is fine-tuned for optimal
              search engine visibility and user engagement. We optimize your
              site's structure, internal linking, and HTML tags to improve
              readability for search engines and users alike. This meticulous
              attention to detail helps in improving your site's relevancy and
              authority in search results.{" "}
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 technical-seo-icon"></div>
            <h5>Technical SEO Audits</h5>
            <p>
              We delve into the technical aspects of your website, identifying
              and rectifying issues that could hinder your search engine
              performance. Our technical SEO audits cover a wide array of
              elements, including site architecture, crawl errors, sitemap
              optimization, and more. By resolving these technical issues, we
              enhance your site’s crawlability and indexation, crucial factors
              for SEO success.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 quality-icon"></div>
            <h5>Quality Backlink Creation</h5>
            <p>
              Our approach to backlink creation focuses on quality over
              quantity, building authoritative and relevant links that boost
              your site's credibility and ranking. We engage in ethical
              link-building practices, seeking out opportunities to earn
              backlinks from reputable and relevant websites. This not only
              improves your search engine rankings but also drives quality
              traffic to your site.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 customized-icon"></div>
            <h5>Customized Content Writing</h5>
            <p>
              We create content that speaks directly to your audience, engaging
              them with relevant, informative, and SEO-friendly material. Our
              content strategy is not just about incorporating keywords; it’s
              about delivering value, building authority, and engaging your
              audience. Each piece of content is crafted to address the needs
              and interests of your target audience while aligning with SEO best
              practices.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 comprehensive-icon"></div>
            <h5>Comprehensive Reporting</h5>
            <p>
              Our reporting is detailed and transparent, providing you with
              insights into your SEO performance and the impact of our
              strategies on your business growth. We offer regular reports that
              include key metrics such as traffic, rankings, and conversions.
              This enables you to see the tangible results of our SEO efforts
              and understand the ROI of your investment in our services.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="inside-chooser">
    <div className="container-lg inner-container position-relative">
      <div className="row">
        <div className="col-lg-6 pe-xl-5">
          <h4 className="tp-ms-head">
            Why Choose <b>Purplepatch</b> for Your{" "}
            <span className="c-primary1">B2B SEO</span> Services?
          </h4>
          <p className="tp-ms-desc">
            Choosing Purplepatch Services for your B2B SEO needs means
            partnering with a team that:
          </p>
        </div>
        <div className="col-lg-6 px-xl-5">
          <ul className="list-style-1 list-style-1-cnt">
            <li>
              <span className="hhtop">Understands B2B Markets:</span>
              <p>
                Our deep understanding of B2B markets enables us to tailor
                strategies that resonate with your specific audience.
              </p>
            </li>
            <li>
              <span className="hhtop">Delivers Measurable Results:</span>
              <p>
                We focus on delivering measurable results, ensuring that every
                aspect of our SEO strategy contributes to your business growth.
              </p>
            </li>
            <li>
              <span className="hhtop">Employs the Latest Techniques:</span>
              <p>
                We stay ahead of the latest SEO trends and algorithm updates,
                ensuring your strategy remains cutting-edge and effective.
              </p>
            </li>
            <li>
              <span className="hhtop">
                Prioritizes Transparent Communication:
              </span>
              <p>
                Our team values clear and consistent communication, ensuring
                you're always informed about your campaign's progress.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section className="seo-accordion accordion-style">
    <div className="container-lg inner-container position-relative text-white">
      <h4 className="ts-parallel text-black ui-mb-res-60">
        FAQs about B2B SEO
      </h4>
      <div className="accordion" id="ac1">
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              What are B2B SEO Services?
            </button>
          </h5>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                B2B SEO services involve optimizing a business's online presence
                to improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              How Much Do B2B SEO Services Cost?
            </button>
          </h5>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                2B SEO services involve optimizing a business's online presence
                to improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Why Do I Need B2B SEO Services?
            </button>
          </h5>
          <div
            id="collapseThree"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                B SEO services involve optimizing a business's online presence
                to improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsefour"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Is SEO Effective for B2B?
            </button>
          </h5>
          <div
            id="collapsefour"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsefive"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              How Is B2B SEO Different from B2C SEO?
            </button>
          </h5>
          <div
            id="collapsefive"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsesix"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              How Do You Create a B2B SEO Strategy?
            </button>
          </h5>
          <div
            id="collapsesix"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseseven"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              How Do I Know If I Need a B2B SEO Agency?
            </button>
          </h5>
          <div
            id="collapseseven"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseeight"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Why Should I Engage with a B2B SEO Agency?
            </button>
          </h5>
          <div
            id="collapseeight"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsenine"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              How Do I Find the Best B2B SEO Agency for My Campaign?
            </button>
          </h5>
          <div
            id="collapsenine"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section
    className="footer-above-services text-white"
    style={{ backgroundImage: "url(assets/img/footer-above-services.png)" }}
  >
    <div className="container-lg inner-container">
      <h3 className="tp-set">
        Get Started with <span className="c-FDB3D4">B2B SEO Services</span>
      </h3>
      <div className="row">
        <div className="col-xl-7 pe-lg-4">
          <p>
            Embark on a journey to enhanced online visibility and business
            growth with Purplepatch Services. Contact us for a consultation and
            discover how our tailored SEO strategies can elevate your B2B
            business.
          </p>
          <p>
            Choosing <b>Purplepatch Services</b> means opting for a partner who
            is dedicated to understanding your unique business needs and
            delivering SEO solutions that drive real results.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section
    className="get-form-touch"
    style={{ backgroundImage: "url(assets/img/get-form-touch.png)" }}
  >
    <div className="container-lg inner-container">
      <div className="row">
        <div className="col-md-6 text-white">
          <h5 className="ss-1">Contact</h5>
          <h4 className="ss-2">
            Ready to start your growth with Our B2B Digital Marketing Service?
          </h4>
          <div className="home-feat-article">
            <div className="dflex-1 text-black">
              <div className="dflex-1-cnt">
                <h6>Featured Article</h6>
                <h5>What is good conversion rate?</h5>
              </div>
              <div className="dflex-1-icon">
                <img src="assets/img/peop-1.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 text-white">
          <h6 className="ss-3">
            Your success story begins here. Connect with us today!
          </h6>
          <p>
            Are you ready to start elevating your brand and getting results?
            Then stop reading and start typing! Fill out the form and let’s
            begin…
          </p>
        </div>
      </div>
    </div>
  </section>
  
</>
  );
};

export default SEO;